import { gql } from "@apollo/client";

const GET_DISPUTE_CONFIG = gql`
  query GetDisputeConfig($params: DisputeConfigInputParams!) {
    disputeConfig(params: $params) {
      disputeTypes {
        disputeTypeId
        disputeTypeName
        disputeTypeKey
        deductionTypeIds
        deductionValidityRcaIds
        isCustomerDeduction
        children {
          disputeTypeId
          disputeTypeName
          disputeTypeKey
          deductionTypeIds
          deductionValidityRcaIds
        }
      }
      disputeContacts {
        name
        email
      }
      isDocumentsRequiredConfig {
        deductionTypeId
        isDocumentsRequired
      }
      portalKey
      noteTemplate
      vendorNumber
      distributionCenters {
        dcId
        dcCode
        dcName
        purchaserId
        purchaserName
      }
      dataProviderType
    }
  }
`;

export default GET_DISPUTE_CONFIG;
